import _ from 'lodash';
import Rx from 'ub_wrapped/rx';

import FontActions from 'ub/fonts/font-picker/font-actions';

const modalActionsSubject = new Rx.Subject();
const stateChangedSubject = new Rx.Subject();

let currentState = {};

stateChangedSubject.subscribe((newState) => {
  currentState = newState;
});

modalActionsSubject
  .filter((ev) => { return !_.isEmpty(ev.type); })
  .subscribe((ev) => {
    const newState = FontActions[ev.type](currentState, ev.data);

    stateChangedSubject.onNext(newState);
  });

export default {
  stateChangedSubject,
  modalActionsSubject
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/state-controller.js